import { h } from 'preact';
import { BeansLiquidEngine } from '@/base/helpers';
import useTemplet from '@/bamboo/hooks';

export default function Popup({ ruleUid, variables }) {
  const { templet } = useTemplet({ ruleUid });
  if (templet) {
    const renderedTempletHTML = BeansLiquidEngine.parseAndRenderSync(templet.html, {
      ...variables,
      Params: templet.settings,
    });

    return <div dangerouslySetInnerHTML={{ __html: renderedTempletHTML }} />;
  }
}
